<template>
  <div>
    <div>
      <!-- Home page content -->
      <main role="main">
        <!-- Intro Section -->
        <div class="intro-blk py-5">
          <div class="text-center container">
            <h1 class="text-center mb-1 text-campaign-green" v-html="$t('Home.IntroTitle')"></h1>
            <h2 class="text-center mb-3 text-body-color  text-uppercase" v-html="$t('Home.IntroSub')"></h2>
            <p class="home-paragraph mb-0 mx-auto" v-html="$t('Home.IntroDesc')"></p>
          </div>
        </div>

        <!-- How To Participate Section -->
        <div class="how-to-blk py-5 bg-light-gray">
          <div class="container-fluid">
            <h2 class="text-center mb-5 text-campaign-green text-uppercase ">{{ $t('Home.HowToParticipateTitle')
            }}</h2>
            <div class="row text-center d-flex justify-content-center px-md-5">
              <div class="col-md-4 mb-4 mb-md-0">
                <div class="home-card bg-transparent border-0 shadow-none">
                  <img :src="$t('Home.ShopImg')" :alt="$t('Home.ShopTitle')" class="img-fluid mb-3 participate-icon" />
                  <h4 class="text-campaign-green text-uppercase ">{{ $t('Home.ShopTitle') }}</h4>
                  <p class="text-dark mx-auto px-md-5">
                    <small v-html="$t('Home.ShopDetail')"></small>
                  </p>
                </div>
              </div>

              <div class="col-md-4 mb-4 mb-md-0">
                <div class="home-card bg-transparent border-0 shadow-none">
                  <img :src="$t('Home.SnapImg')" :alt="$t('Home.SnapTitle')" class="img-fluid mb-3 participate-icon" />
                  <h4 class="text-campaign-green text-uppercase ">{{ $t('Home.SnapTitle') }}</h4>
                  <p class="text-dark mx-auto px-md-5">
                    <small v-html="$t('Home.SnapDetail')"></small>
                  </p>
                </div>
              </div>

              <div class="col-md-4">
                <div class="home-card bg-transparent border-0 shadow-none">
                  <img :src="$t('Home.SendImg')" :alt="$t('Home.SendTitle')" class="img-fluid mb-3 participate-icon" />
                  <h4 class="text-campaign-green text-uppercase ">{{ $t('Home.SendTitle') }}</h4>
                  <p class="text-dark mx-auto px-md-5">
                    <small v-html="$t('Home.SendDetail')"></small>
                  </p>
                </div>
              </div>
            </div>

            <div class="text-center mt-3 pt-3">
              <p class="small mt-5">Trouble participating? Check our <router-link :to="{ name: 'FAQ' }"
                  data-gtm-elem="navigation-click" data-gtm-card-type="Learn More"
                  :data-gtm-card-title="$t('Home.HowToParticipateTitle')" data-gtm-link-text="FAQs">FAQs
                  ›</router-link></p>
            </div>
          </div>
        </div>

        <!-- RAISE A MARG Section -->
        <div class="raise-marg-blk py-5">
          <div class="container text-center">
            <h2 class="mb-2 text-campaign-green text-uppercase ">{{ $t('Home.RaiseMargTitle') }}</h2>
            <p class="mb-5 text-dark ">{{ $t('Home.RaiseMargSub') }}</p>

            <div class="carousel-container position-relative">
              <button class="carousel-control prev-arrow d-md-none" @click="scrollCarousel(-1)">
                <img
                  src="https://snippcheck.blob.core.windows.net/files/Suntory_2008309_HornitosDiadelosMuertos2025/arrow-left.png"
                  alt="Previous" />
              </button>

              <div class="carousel-track d-flex" ref="carouselTrack">
                <div class="carousel-card" v-for="marg in margaritas" :key="marg.uniqueId" @click="openModal(marg)"
                  style="cursor: pointer;" tabindex="0" @keydown.enter="openModal(marg)"
                  data-gtm-elem="navigation-click" data-gtm-card-type="Cocktail link" :data-gtm-card-title="marg.title"
                  :data-gtm-link-text="marg.title">
                  <img :src="marg.image" :alt="marg.title" class="img-fluid w-100" />
                  <div :class="['card-title-blk', marg.bgClass, 'd-none']">
                    <h3 class="text-uppercase  text-center m-0" v-html="marg.title.replace(' ', '<br>')">
                    </h3>
                  </div>
                </div>
              </div>

              <button class="carousel-control next-arrow d-md-none" @click="scrollCarousel(1)">
                <img
                  src="https://snippcheck.blob.core.windows.net/files/Suntory_2008309_HornitosDiadelosMuertos2025/arrow-right.png"
                  alt="Next" />
              </button>
            </div>

            <p class="mt-5 text-dark footer-text">{{ $t('Home.RaiseMargFoot') }}</p>
          </div>
        </div>
      </main>
    </div>

    <!-- Modal Overlay -->
    <transition name="fade">
      <div v-if="isModalOpen" class="modal-overlay" @click.self="closeModal">
        <button class="modal-nav-arrow prev-arrow" @click.stop="navigateModal(-1)" aria-label="Previous Cocktail">
          <img src="https://snippcheck.blob.core.windows.net/files/Suntory_2008309_HornitosDiadelosMuertos2025/arrow-left.png" alt="Previous" />
        </button>

        <transition :name="slideDirection" mode="out-in">
          <div class="margarita-modal" role="dialog" aria-modal="true" :key="activeMargarita.id">
            <div class="modal-content-inner">
            <!-- Section 1: White Header -->
            <div class="modal-header-white text-center position-relative">
              <button class="modal-close" @click="closeModal" aria-label="Close modal">
                <span aria-hidden="true">&times;</span>
              </button>
              <h2 class="modal-logo-text text-campaign-green  text-uppercase m-0">
                <small>RAISE A MARG &</small>
                SALUD TO <br>ALL SOULS
              </h2>
              <router-link :to="{ name: 'Enter' }"
                class="continue-enter-btn mt-3 d-inline-flex align-items-center justify-content-center"
                @click="closeModal">
                CONTINUE TO ENTER
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                  class="bi bi-arrow-right ms-2" viewBox="0 0 16 16">
                  <path fill-rule="evenodd"
                    d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                </svg>
              </router-link>
            </div>

            <!-- Section 2: Green Hero Image -->
            <div class="modal-hero-green text-center">
              <img :src="activeMargarita.imagepop" :alt="activeMargarita.title"
                class="modal-marg-img img-fluid mx-auto d-block" />
            </div>

            <!-- Section 3: Tinted Content -->
            <div :class="['modal-content-tinted', 'text-center', activeMargarita.tintClass]">
              <h2 class="text-campaign-green  text-uppercase m-0" v-html="activeMargarita.title.replace(' ', '<br>')">
              </h2>

              <p class="marg-desc mt-3 mx-auto">{{ activeMargarita.desc }}</p>
              <div class="recipe-grid">
                <div class="recipe-method mt-4 mb-4 text-start">
                  <h4 class="text-campaign-green  text-uppercase">METHOD</h4>
                  <p>{{ activeMargarita.method }}</p>
                </div>
                <div class="mt-4 text-start d-flex justify-content-between flex-column flex-md-row">
                  <div class="col-left w-100 w-md-50 pe-md-3">


                    <div class="recipe-ingredients">
                      <h4 class="text-campaign-green  text-uppercase">INGREDIENTS</h4>
                      <p v-html="activeMargarita.ingredients"></p>
                    </div>
                  </div>

                  <div class="col-right w-100 w-md-50 ps-md-3 mt-4 mt-md-0">
                    <div class="recipe-glassware mb-4">
                      <h4 class="text-campaign-green  text-uppercase">GLASSWARE</h4>
                      <p>{{ activeMargarita.glassware }}</p>
                    </div>

                    <div class="recipe-garnish">
                      <h4 class="text-campaign-green  text-uppercase">GARNISH</h4>
                      <p v-html="activeMargarita.garnish"></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </div>
          </div>
        </transition>

        <button class="modal-nav-arrow next-arrow" @click.stop="navigateModal(1)" aria-label="Next Cocktail">
          <img src="https://snippcheck.blob.core.windows.net/files/Suntory_2008309_HornitosDiadelosMuertos2025/arrow-right.png" alt="Next" />
        </button>
      </div>
    </transition>
  </div>
</template>
<script>
import { getMargaritas } from '../../data/margaritas';

export default {
  props: {
    startDate: {
      type: Date,
      required: true,
    },
    endDate: {
      type: Date,
      required: true,
    },
  },
  data() {
    return {
      isModalOpen: false,
      activeMargarita: null,
      slideDirection: 'slide-left',
      margaritas: [],
      baseMargaritas: []
    };
  },
  mounted() {
    this.baseMargaritas = getMargaritas(this.$t);

    // To allow scrolling on desktop (where 3 cards fit perfectly), we duplicate the items
    // creating enough overflow for the arrows to slide through multiple sets of cards.
    this.margaritas = [
      ...this.baseMargaritas.map((m, i) => ({ ...m, uniqueId: `${m.id}-set1-${i}` })),
      ...this.baseMargaritas.map((m, i) => ({ ...m, uniqueId: `${m.id}-set2-${i}` })),
      ...this.baseMargaritas.map((m, i) => ({ ...m, uniqueId: `${m.id}-set3-${i}` })),
      ...this.baseMargaritas.map((m, i) => ({ ...m, uniqueId: `${m.id}-set4-${i}` }))
    ];

    document.addEventListener('keydown', this.handleKeydown);
  },
  beforeUnmount() {
    document.removeEventListener('keydown', this.handleKeydown);
  },
  methods: {
    navigateModal(direction) {
      if (!this.activeMargarita) return;
      this.slideDirection = direction === 1 ? 'slide-left' : 'slide-right';
      const currentIndex = this.baseMargaritas.findIndex(m => m.id === this.activeMargarita.id);
      if (currentIndex !== -1) {
        let newIndex = currentIndex + direction;
        if (newIndex < 0) newIndex = this.baseMargaritas.length - 1;
        if (newIndex >= this.baseMargaritas.length) newIndex = 0;
        this.activeMargarita = this.baseMargaritas[newIndex];
      }
    },
    openModal(marg) {
      this.activeMargarita = marg;
      this.isModalOpen = true;
      document.body.style.overflow = 'hidden'; // Prevent background scrolling
    },
    closeModal() {
      this.isModalOpen = false;
      setTimeout(() => {
        this.activeMargarita = null;
      }, 300); // Wait for transition
      document.body.style.overflow = '';
    },
    handleKeydown(e) {
      if (e.key === 'Escape' && this.isModalOpen) {
        this.closeModal();
      } else if (e.key === 'ArrowLeft' && this.isModalOpen) {
        this.navigateModal(-1);
      } else if (e.key === 'ArrowRight' && this.isModalOpen) {
        this.navigateModal(1);
      }
    },
    scrollCarousel(direction) {
      const track = this.$refs.carouselTrack;
      if (track && track.firstElementChild) {
        // Calculate scroll amount based on one card's actual width + gap (15px)
        const scrollAmount = track.firstElementChild.offsetWidth + 15;
        track.scrollBy({ left: direction * scrollAmount, behavior: 'smooth' });
      }
    },
    // New method: make <a> behave like router-links
    handleLinkClick(event) {
      const target = event.target.closest('a');
      if (target) {
        const href = target.getAttribute('href');

        // Only intercept internal links (those starting with '/')
        if (href && href.startsWith('/')) {
          event.preventDefault();
          const routeName = href.substring(1); // e.g. 'FAQ' from '/FAQ'

          if (routeName) {
            this.$router.push({ name: routeName }).catch(() => {
              // Fallback if route name doesn't exist
              this.$router.push(href);
            });
          }
        }
      }
    },
  }
};
</script>
